var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "enhancements-list",
      attrs: { "data-component": "enhancements-list" },
    },
    _vm._l(_vm.enhancementsList, function (enhancement) {
      return _c("enhancement-card", {
        key: enhancement.name,
        attrs: {
          enhancement: enhancement,
          "number-of-selected-enhancements": _vm.selectedEnhancements,
          "ignore-max-number": _vm.ignoreMaxNumber,
        },
        on: {
          "select-enhancement": _vm.selectEnhancement,
          "remove-enhancement": function ($event) {
            return _vm.$emit("remove-enhancement", $event)
          },
          "edit-enhancement": function ($event) {
            return _vm.$emit("edit-enhancement", $event)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }